export const DEFAULT_CURRENCY = {
  code: 'USD',
  name: 'US Dollar',
  symbol: '$',
};
